// extracted by mini-css-extract-plugin
export var alignDiscLeft = "m_qh d_fp d_bG d_dv";
export var alignLeft = "m_qj d_fp d_bG d_dv";
export var alignDiscCenter = "m_qk d_fq d_bD d_dw";
export var alignCenter = "m_bP d_fq d_bD d_dw";
export var alignDiscRight = "m_ql d_fr d_bH d_dx";
export var alignRight = "m_qm d_fr d_bH d_dx";
export var footerContainer = "m_qn d_dW d_bW";
export var footerContainerFull = "m_qp d_dT d_bW";
export var footerHeader = "m_kf d_kf";
export var footerTextWrapper = "m_qq d_w";
export var footerDisclaimerWrapper = "m_km d_km d_ck";
export var badgeWrapper = "m_qr d_w d_bz d_bP d_bF d_bJ";
export var verticalTop = "m_qs d_bz d_bJ d_bN d_bL";
export var wide = "m_qt d_cy";
export var right = "m_qv d_bK";
export var line = "m_fk d_fl d_cv";
export var badgeDisclaimer = "m_qw d_bC d_bP d_bJ";
export var badgeContainer = "m_qx d_bz d_bH d_bP";
export var badge = "m_qy";
export var padding = "m_qz d_c7";
export var end = "m_qB d_bH";
export var linkWrapper = "m_qC d_dB";
export var link = "m_mZ d_dB";
export var colWrapper = "m_qD d_cx";
export var consent = "m_f d_f d_bC d_bP";
export var disclaimer = "m_qF d_bz d_bJ";
export var media = "m_qG d_bx d_dy";
export var itemRight = "m_qH";
export var itemLeft = "m_qJ";
export var itemCenter = "m_qK";
export var exceptionWeight = "m_qL p_rd";